document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.global-video-control__button');
  const container = document.querySelector('.global-video-control');
  let videos = document.querySelectorAll('video');
  let isPlaying = false;
  let initialStateSet = false;

  // Toggle videos and update state
  button.addEventListener('click', () => {
    isPlaying = !isPlaying;
    button.classList.toggle('global-video-control__button--paused', !isPlaying);
    videos.forEach(v => isPlaying ? v.play() : v.pause());
  });

  // Enforce toggle state when videos are visible
  const viewObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        if (isPlaying) video.play();
        if (!isPlaying) video.pause();
      }
    });
  }, { threshold: 0.1 });

  // Update video list and state
  function updateVideos() {
    videos = document.querySelectorAll('video');
    container.style.display = videos.length ? 'block' : 'none';

    if (videos.length > 0 && !initialStateSet) {
      initialStateSet = true;
      isPlaying = true;
      button.classList.toggle('global-video-control__button--paused', !isPlaying);
    }

    videos.forEach(video => viewObserver.observe(video));
  }

  // Watch for new videos
  new MutationObserver(updateVideos).observe(document.body, {
    childList: true,
    subtree: true
  });

  updateVideos(); // Initial call

  // Disable click event on all video elements
  videos.forEach(video => {
    video.addEventListener('click', event => {
      event.stopPropagation();
    }, true);
  })

  // Prevent video from playing when scrolling
  window.addEventListener('scroll', event => {
    if (isPlaying === false) {
      videos.forEach(video => {
        video.pause()
      })
    }
  });

  // Safari autoplay delay hack -_-
  if (!window.navigator.userAgent.toLowerCase().includes('safari')) {
    return
  } else {
    const videoBanners = document.querySelectorAll('#video-banner')
    
    videoBanners.forEach(video => {
      setTimeout(() => {
        video.pause();  
        video.play();
      }, 500)
    })
  }
});
